// AI Generated Component
import { AfterViewInit, Component, Input, OnInit, ViewChild } from '@angular/core';
import { PolicyFormHelperService } from '@client/app/blocks/helpers/policy-form-helper/policy-form.helper.service';
import { MonDialog } from '@client/app/modules/dialog-upgrade-wrapper/mon-dialog.service';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { FormUtils } from '@client/ng2/shared/form-utils';
import { NgForm } from '@angular/forms';

import { safeClone } from '@client/app/shared/utils/object-utils';
@Component({
    selector: 'form-global-policy-dialog-rule-file-size',
    templateUrl: './file-size.component.html',
    standalone: false,
})
export class FormGlobalPolicyDialogRuleFileSizeComponent implements OnInit, AfterViewInit {
    @Input() cRule: any;
    @Input() monDialogId: any;

    @ViewChild('policyRuleForm') policyRuleForm?: NgForm;

    typeOptions: any;
    dropdownOptions: any;
    selectedOperator: any;
    sizeOptions: any;
    dropdownSizeOptions: any;
    selectedSize: any;

    constructor (
        private policyFormHelperService: PolicyFormHelperService,
        private monDialog: MonDialog,
        private translateService: TranslateService,
    ) {}

    ngOnInit (): void {
        this.activate();
    }

    ngAfterViewInit () {
        this.monDialog.setFocus(this.monDialogId, this.policyRuleForm);
    }

    activate (): void {
        this.cRule.inverse = false;
        this.cRule.query = this.cRule.query || '';
        this.policyFormHelperService.setRuleType(this.cRule.type);
        this.setupTypeOptions();
        this.setupSizeOptions();
        if (!this.cRule.name) {
            this.chooseOperator(this.typeOptions.length > 0 ? this.typeOptions[0] : {});
        } else {
            this.chooseOperator(
                this.typeOptions.find((type: any) => {
                    return type.type === this.cRule.operator;
                }),
            );
        }
    }

    setupTypeOptions (): void {
        this.typeOptions = this.policyFormHelperService.getOptionsByRuleType();
        this.dropdownOptions = this.policyFormHelperService.getMenuDropdownOptionsByRuleType(option => this.chooseOperator(option));
    }

    chooseOperator (option: any): void {
        this.selectedOperator = option;
        this.cRule.operator = option.type;
    }

    chooseSize (option: any): void {
        this.selectedSize = option;
    }

    setupSizeOptions (): void {
        const queryStr = this.cRule.query.replace(/(kb|mb)/, '');
        this.sizeOptions = this.policyFormHelperService.getOptionsByRuleSize();
        this.dropdownSizeOptions = this.policyFormHelperService.getMenuDropdownOptionsByRuleSize(this.chooseSize.bind(this));

        if (queryStr === this.cRule.query) {
            this.chooseSize(this.sizeOptions[0]);
        } else {
            const size = this.cRule.query.substring(queryStr.length, this.cRule.query.length);
            this.chooseSize(
                this.sizeOptions.find((option: any) => {
                    return option.value === size;
                }),
            );
        }

        const parsed = parseInt(queryStr);
        if (!isNaN(parsed)) {
            this.cRule.query = parsed;
        }
    }

    close (): void {
        const newRule = safeClone(this.cRule);
        newRule.sub_entry = newRule.sub_entry.join(',');
        newRule.query = newRule.query === '' ? 0 : this.cRule.query;
        newRule.query = newRule.query + this.selectedSize.value;
        FormUtils.markFormAsPristine(this.policyRuleForm);
        this.monDialog.close(this.monDialogId, newRule);
    }
}
